export default __webpack_public_path__ + "static/media/femme-forte-gold.f40dce60.jpeg";